module.exports = __webpack_public_path__ + "img/Feature.ee600663.png";